import { useEffect, useState } from "react";
import { Copy, Download, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { api, errMsg, downloadFile } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Card } from "../components/Card";

export default function BuildPrompt() {
  const { t } = useI18n();
  const { isAdmin } = useAuth();
  const [prompt, setPrompt] = useState("");
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/build-prompt").then((r) => setPrompt(r.data.prompt)); }, []);
  const copy = async () => {
    try { await navigator.clipboard.writeText(prompt); } catch (_) {
      const ta = document.createElement("textarea"); ta.value = prompt; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true); toast.success(t("copied")); setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div>
      <PageHeader title={t("nav_prompt")} sub={t("promptSub")}>
        <Button data-testid="copy-prompt-button" variant="outline" onClick={copy} className="rounded-xl">{copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{t("copy")}</Button>
        {isAdmin && <Button data-testid="download-prompt-docx-button" onClick={() => downloadFile("/export/build-prompt.docx", "Base44_GRC_Task_Manager_Implementation_Guide.docx").catch((e) => toast.error(errMsg(e)))} className="rounded-xl bg-slate-900"><Download className="h-4 w-4" />{t("downloadDocx")}</Button>}
      </PageHeader>
      <Card>
        <pre data-testid="build-prompt-text" dir="ltr" className="max-h-[70vh] overflow-auto whitespace-pre-wrap font-mono text-xs leading-relaxed text-slate-800 sm:text-sm">{prompt}</pre>
      </Card>
    </div>
  );
}
